<template>
    <svg aria-hidden="true" focusable="false" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="22" fill="white" stroke="#9D9FA2" />
        <path d="M14.5588 31.7647V21.1764C14.5588 19.5196 15.902 18.1764 17.5588 18.1764L29.8639 18.1764" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M24.8422 22.8432L30.4412 18.0392L24.8422 13.2353" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>
